export const calculatePaymentDatesFromDocuments = (
  documents: any,
  creditDetails: any,
) => {
  const firstPaymentDate = new Date(documents[0].paymentDate);
  const paymentDates: any[] = [];
  const firstDiff = Math.floor(
    (firstPaymentDate.getTime() -
      new Date(creditDetails.operationDate).getTime()) /
      (1000 * 60 * 60 * 24),
  );
  paymentDates.push({
    date: new Date(creditDetails.firstPaymentDate),
    diffDays: firstDiff,
  });
  for (let i = 1; i < documents.length; i++) {
    const lastEntry = paymentDates[i - 1];
    const diffDays = Math.floor(
      (new Date(documents[i].paymentDate).getTime() -
        lastEntry.date.getTime()) /
        (1000 * 60 * 60 * 24),
    );
    paymentDates.push({ date: new Date(documents[i].paymentDate), diffDays });
  }
  return paymentDates;
};
